//BlogPage.js
///////////////////////////////
//React & Material
import { motion } from "framer-motion";
import React from 'react';
import { Col, Image, Row, Badge } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
//Plugins
import styled from 'styled-components';
import AboutMe from '../../components/AboutMe';
import GridGenerator from '../../components/GridGenerator.jsx';
import MainBlogPost from '../../components/MainBlogPost';
import SingleBlogPost from '../../components/SingleBlogPost';
import ThanksSection from '../../components/ThanksSection';
import Fist from '../../media/blogs/fist-light.png';
import DigitalBadge from '../../media/digital-media.png'
import Thumbs from '../../media/blogs/thumbs.png';
import Blogs from '../../blogs/blogs.json'
//////////////////////////////
//Styled components
const Wrapper = styled(Container)`
margin-top:10vh;
@media only screen and (max-width: 767px) {
    margin-top:5vh;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    margin-top:4vh;
  }
`

const HeroSection = styled(Row)`
  text-align: center;
//   padding:5px 0px;
  color: white;
`
const HeadingTitle = styled.h1`
color:#36FFC1;
font-weight:bold;
`

const SubHeading = styled.h1`
margin-top:5px;
font-weight:bold;
`
const AndSign = styled.h3`
font-weight:200;
display:inline-block;
color: rgba(255, 255, 255, 0.35);
&:hover{
    color:white;
  }
`
const FistImage = styled(Image)`
filter: drop-shadow(-10px 20px 35px rgba(54, 255, 193, 0.1));

@media only screen and (max-width: 767px) {
    margin-bottom:30px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    margin-bottom:30px;
  }
`

const HandImage = styled(Image)`
filter: drop-shadow(13px 60px 35px rgba(54, 255, 193, 0.1));
transform: rotate(-15deg);

@media only screen and (max-width: 767px) {
    margin-top:40px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    margin-top:40px;
  }
`
const Subtitle = styled.h5`
&:hover{
    color:white;
  }
  margin-top:30px;
color: rgba(255, 255, 255, 0.35);
`

const Spacer = styled.div`
  width: 10px;
  height: ${props => props.height}px;
`
const Cert = styled(Image)`
    width:230px;
`

const CredRow = styled(motion.div)`
  display:flex;
    align-items:center;
    justify-content:center;
    flex-direction:column;
    margin-top:20px;
`
const CustomBadge = styled(Badge)`
border: 1px solid #36FFC1;
background:black;
color:#36FFC1;
padding:5px 15px 5px 15px;
font-weight:bold;
margin-bottom:15px;
// margin-left:15px;
`
const CustomLink = styled.a`
text-decoration: none;
-webkit-transition: color 1s ease-out;
-moz-transition: color 1s ease-out;
-o-transition: color 1s ease-out;
-ms-transition: color 1s ease-out;
transition: color 1s ease-out;
    &:focus, &:visited, &:link, &:active {
        text-decoration: none;
        color:inherit;
    }
    &:hover{
      text-decoration: none;
      color:#36FFC1;
    }
`
//////////////////////////////
//Component class
/**
 * Displays a template component
 */
function BlogPage(props) {

    const recentBlog = Blogs.recentBlog;
    const pastBlogs = Blogs.pastBlogs;

    const RenderPastBlogs = pastBlogs.map((blog) =>
        <SingleBlogPost content={blog} />
    );
    const RenderBlogs = () => {
        return (
            <>
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{
                    duration: 2,
                    ease: "easeIn",
                    delay: 2.5
                }}>
                    <MainBlogPost content={recentBlog} />
                </motion.div>
                <Spacer height="100" />
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{
                    duration: 2,
                    ease: "easeIn",
                    delay: 2.8
                }}>
                    <GridGenerator cols={2}>
                        {RenderPastBlogs}
                    </GridGenerator>
                </motion.div>
            </>
        )
    }
    return (
        <Wrapper>
            <HeroSection>
                <Col sm={true}>
                    <motion.div
                        animate={{
                            x: [0, 20, 30, 20, 0],
                            y: [0, 40, -30, 20, 0],
                            scale: [1, 1.2, 1.2, 1, 1],
                            rotate: [0, 0, 20, -20, 0],
                        }}

                        transition={{
                            duration: 4,
                            ease: "easeInOut",
                            times: [0, 0.2, 0.5, 0.8, 1],
                            loop: Infinity,
                        }}

                        whileHover={{ scale: 1.3 }}
                    >
                        <FistImage fluid src={Fist} />
                    </motion.div>
                </Col>
                <Col sm={true}>
                    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{
                        duration: 2,
                        ease: "easeIn"
                    }}>
                        <HeadingTitle>
                            Latest Blogs
                        </HeadingTitle>
                    </motion.div>
                    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{
                        duration: 2,
                        ease: "easeIn",
                        delay: 1
                    }}>
                        <SubHeading>
                            <AndSign>&</AndSign> Updates
                        </SubHeading>
                    </motion.div>
                    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{
                        duration: 2,
                        ease: "easeIn",
                        delay: 1.5
                    }}>
                        <Subtitle>
                            Trending topics explained differently with interesting twists
                        </Subtitle>
                    </motion.div>
                </Col>
                <Col sm={true}>
                    <motion.div
                        animate={{
                            y: [0, -10, -5, 0, 5],
                            rotate: [0, 0, 10, -10, 0],
                        }}
                        transition={{
                            duration: 3,
                            ease: "easeInOut",
                            times: [0, 0.2, 0.5, 0.8, 1],
                            yoyo: Infinity

                        }}
                        whileHover={{ scale: 1.3 }}
                    >
                        <HandImage fluid src={Thumbs} />
                    </motion.div>
                </Col>
            </HeroSection>
            <Spacer height="200" />
            {RenderBlogs()}

            <CustomLink href="http://t.cred.ly/l/1237bf38-bdf6-43d3-bc46-c72673540cc5" target="_blank" rel="noopener noreferrer">
                <CredRow initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{
                    duration: 2,
                    ease: "easeIn",
                    delay: 3
                }}>

                    <CustomBadge variant="info">RMIT Creds</CustomBadge>
                    <Cert src={DigitalBadge} fluid />


                </CredRow>
            </CustomLink>

            <Spacer height="30" />
            <AboutMe />
            <Spacer height="200" />
            <ThanksSection />
        </Wrapper>
    )
}
export default BlogPage;